import React from "react";
import { Controller, useFormContext } from "react-hook-form";

import Select from "@/components/Atoms/Inputs/Select";
import ErrorUI from "@/components/Atoms/ErrorUI";

import { InputGroup, InputWrapper } from "../style";

const GoalsSelect = ({
  name,
  control,
  goalPlaceholder,
  goalOptions,
  fontSize,
  handleBlur,
  removeAppliedPromoCode,
}) => {
  const { getValues, setError } = useFormContext();

  const promoCode = getValues("promoCode"); //TODO: Make this `PromoCode` string dynamic

  return (
    <InputWrapper>
      <InputGroup>
        <Controller
          name={name}
          control={control}
          shouldUnregister
          render={({
            field: { value, onBlur, onChange, ref },
            fieldState: { error },
            formState: { errors },
          }) => (
            <>
              <Select
                // ref={ref}
                options={goalOptions}
                dropDownHeight="150px"
                placeholder={goalPlaceholder}
                name={name}
                value={goalOptions.find(
                  (selectedOption) => selectedOption.value === value
                )}
                onBlur={(e) => {
                  onBlur(e).then((e) => {
                    if (!errors?.[name]) handleBlur(e);
                  });
                }}
                onChange={(goal) => {
                  if (goal?.value && promoCode) {
                    removeAppliedPromoCode();
                    setError("promoCode", {
                      type: "custom",
                      message: `Promo code has removed, your promo code was "${promoCode}". Please apply promo code again.`,
                    });
                  }

                  onChange(goal?.value);
                }}
                containerPadding="2px 16px"
                dropdownPos="bottom"
                borderRadius="10px"
                variant="v2"
                isSearchable={false}
                fontSize={fontSize}
              />
              {error && <ErrorUI error={error?.message} />}
            </>
          )}
        />
      </InputGroup>
    </InputWrapper>
  );
};

export default GoalsSelect;
